import { client } from '$lib/api/generated/cta-services/client.gen';
import { getAccessToken } from '@24orebs/auth-lib/client';
import {
	PUBLIC_OKTA_ISSUER,
	PUBLIC_OKTA_CLIENT_ID,
	PUBLIC_OKTA_REDIRECT_URI,
	PUBLIC_CTA_SERVICES_API_KEY,
	PUBLIC_CTA_SERVICES_URL
} from '$env/static/public';

/**
 * Configures the cta-services API client singleton.
 * Sets the Authorization header with the user's
 * Okta access token so all subsequent SDK calls are authenticated.
 *
 * Call once before using any SDK function (e.g. `submitInformationRequest`).
 * After this, all generated SDK functions use the configured client automatically.
 */
export const useCtaServicesApiClient = async () => {
	const accessToken = await getAccessToken({
		issuer: PUBLIC_OKTA_ISSUER,
		clientId: PUBLIC_OKTA_CLIENT_ID,
		redirectUri: PUBLIC_OKTA_REDIRECT_URI
	});

	client.setConfig({
		baseUrl: PUBLIC_CTA_SERVICES_URL!,
		headers: {
			...(accessToken && { Authorization: `Bearer ${accessToken}` }),
			'X-Api-Key': PUBLIC_CTA_SERVICES_API_KEY!
		}
	});
};
